import React, { useState } from 'react';
import { Button, Icon, Snackbar } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import { ImageGalleryDialog } from 'components';


interface ISelectOwnImageProps {
  title: string,
  imagesTagIds: string,
  isOwnImages: boolean,
  selectImageConfigPath: string,
  cols: number,
  rowHeight: number,
  handleSelectImage: (_data, _selectImageConfigPath) => void
}

const SelectOwnImage = ({
  title,
  imagesTagIds,
  isOwnImages,
  selectImageConfigPath,
  handleSelectImage,
  cols,
  rowHeight
}: ISelectOwnImageProps) => {
  const [openImageDialog, toggleOpenImageDialog] = useState<boolean>(false);

  return (
    <>
      <Button
        className="w-full max-w-300 mt-2 mr-2 bg-periwinkle-gray"
        variant="outlined"
        color="primary"
        size="large"
        onClick={() => toggleOpenImageDialog(true)}
      >
        <Icon className="mr-2">wallpaper</Icon>
        Select From Own Images
      </Button>
      {(imagesTagIds && openImageDialog && isOwnImages) ?
        <ImageGalleryDialog
          title={title}
          open={openImageDialog}
          setOpen={toggleOpenImageDialog}
          onImageSelect={(data) => handleSelectImage(data, selectImageConfigPath)}
          imageTagId={imagesTagIds}
          isPrivate
          cols={cols}
          rowHeight={rowHeight}
        />
        :
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          autoHideDuration={3000}
          onClose={() => toggleOpenImageDialog(false)}
          open={openImageDialog}
        >
          <MuiAlert elevation={6} variant="filled" severity="warning">
            You have no your own uploaded images.
            Firstly, you have to upload at least one image.
          </MuiAlert>
        </Snackbar>
      }
    </>
  );
};

export default SelectOwnImage;
